// BERORO スリープベア LP

// 「_btn」画像クリックで説明パート（12_b内）へスムーススクロール
document.querySelectorAll('.js-jump').forEach(function (link) {
  link.addEventListener('click', function (e) {
    var target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth' });
  });
});

// 動画：画面外では停止して負荷を抑える（autoplay属性による自動再生の補助）
(function () {
  var videos = document.querySelectorAll('.lp__video video');
  if (!videos.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.play().catch(function () {});
      } else {
        e.target.pause();
      }
    });
  }, { rootMargin: '200px 0px' });
  videos.forEach(function (v) { io.observe(v); });
})();

// 追従CVバー：バー画像が存在する場合のみ表示し、LP下部にバー分の余白を確保
(function () {
  var bar = document.getElementById('cv_bar');
  if (!bar) return;
  var img = bar.querySelector('img');

  function show() {
    bar.hidden = false;
    document.body.classList.add('has-cv-bar');
    document.documentElement.style.setProperty('--cv-bar-height', bar.offsetHeight + 'px');
  }

  var probe = new Image();
  probe.onload = show;
  probe.src = img.src;

  window.addEventListener('resize', function () {
    if (!bar.hidden) {
      document.documentElement.style.setProperty('--cv-bar-height', bar.offsetHeight + 'px');
    }
  });
})();


document.addEventListener('DOMContentLoaded', ()=>{
  const interval = 500;
  const initializer = setInterval(() => {
    const wrapper = document.querySelector('#ch-plugin-entry > div');
    if(wrapper != null) {
      const root = wrapper.shadowRoot;
      if(root != null) {
        const sheet = new CSSStyleSheet()
        sheet.replaceSync(`
          @media (width < 750px) {
            div[data-ch-testid="launcher"] {
              bottom: 120px!important;
            }
          }
        `)
        root.adoptedStyleSheets = [sheet];
        clearInterval(initializer);
      }
    }
  }, interval);
});